import React from 'react';
import { TemplateProviders } from '../TemplateProviders';
import { ScheduleItem, ScheduleItemRouterProps } from './ScheduleItem';

export const SchedulerItem: React.FC<ScheduleItemRouterProps> = ({ onCloseSDK, ...rest }) => {
  return (
    <TemplateProviders onCloseSDK={onCloseSDK}>
      <ScheduleItem {...rest} />
    </TemplateProviders>
  );
};

export default ScheduleItem;
